(() => {
  if (document.getElementById('evolve-product-image-popup')) return;
  const dialog = document.createElement('dialog');
  if (typeof dialog.showModal !== 'function') return;
  dialog.id = 'evolve-product-image-popup';
  dialog.className = 'evolve-product-image-popup';
  dialog.setAttribute('aria-label', 'Product image preview');
  const close = document.createElement('button');
  close.type = 'button';
  close.className = 'evolve-product-image-popup__close';
  close.setAttribute('aria-label', 'Close image preview');
  close.autofocus = true;
  close.textContent = '×';
  const surface = document.createElement('div');
  surface.className = 'evolve-product-image-popup__surface';
  const large = document.createElement('img');
  large.className = 'evolve-product-image-popup__image';
  large.alt = '';
  const frame = document.createElement('div');
  frame.className = 'evolve-product-image-popup__frame';
  frame.append(large, close);
  surface.append(frame);
  dialog.append(surface);
  function setRatio(image) {
    const ratio = image?.naturalWidth / image?.naturalHeight;
    frame.style.setProperty('--image-ratio', Number.isFinite(ratio) && ratio > 0 ? ratio : 1);
  }
  large.addEventListener('load', () => setRatio(large));
  document.body.append(dialog);
  let opener;
  let previousOverflow = '';

  function open(image) {
    if (dialog.open) return;
    const gallery = image.closest('[data-evolve-gallery]');
    const selected = image.hasAttribute('data-gallery-main')
      ? gallery?.querySelector('[data-gallery-thumb][aria-selected="true"]') : null;
    // Use the selected full-size source even during the gallery's short fade.
    const src = selected?.dataset.src || image.src || image.currentSrc;
    if (!src) return;
    opener = image;
    large.alt = selected?.dataset.alt || image.alt || 'Product preview';
    dialog.setAttribute('aria-label', large.alt);
    setRatio(selected?.querySelector('img') || image);
    large.src = src;
    if (large.complete && large.naturalWidth) setRatio(large);
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
  }

  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog || event.target === surface) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    if (opener?.isConnected) opener.focus({ preventScroll: true });
    large.removeAttribute('src');
  });

  function init(root = document) {
    root.querySelectorAll('[data-gallery-main], [data-bundle-preview-image]').forEach((image) => {
      // PupManager's existing phone popup remains its sole preview handler.
      if (image.closest('.evolve-pupmanager-product, .evolve-app-phone, [data-app-preview], a, button')) return;
      if (image.dataset.imagePopupReady) return;
      image.dataset.imagePopupReady = 'true';
      image.classList.add('evolve-image-popup-trigger');
      image.setAttribute('role', 'button');
      image.tabIndex = 0;
      image.setAttribute('aria-haspopup', 'dialog');
      image.setAttribute('aria-controls', dialog.id);
      if (!image.alt) image.setAttribute('aria-label', 'Open product image preview');
      image.addEventListener('click', () => open(image));
      image.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        open(image);
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (dialog.open && opener && event.target.contains(opener)) dialog.close();
  });
})();
